import React, { useEffect, useRef, useState, memo } from "react";

export const options = [
  { value: "Not Defind", label: "Not Defind" },
  { value: "High", label: "High" },
  { value: "Basic", label: "Basic" },
  { value: "None", label: "None" },
];

export const year = [
  { value: "FY 23 (1st April 2023 to 31st March 2024)", label: "FY 23 (1st April 2023 to 31st March 2024)" },
  { value: "FY 25 (1st April 2025 to 31st March 2026)", label: "FY 25 (1st April 2025 to 31st March 2026)" },
];

export const getFYears = (userRole) => {
  const currentDate = new Date();
  let currentFiscalYear = currentDate.getFullYear(); // FY24
  const currentMonth = currentDate.getMonth();
  if(currentMonth < 3) {
    currentFiscalYear = currentFiscalYear - 1;
  }
  const nextFiscalYear = currentFiscalYear + 1; // FY25

  const fiscalYears = [];

  if (userRole.includes("Operation")) {
    fiscalYears.push({
      value: `FY ${String(currentFiscalYear).slice(-2)} (1st April ${currentFiscalYear} to 31st March ${currentFiscalYear + 1})`,
      label: `FY ${String(currentFiscalYear).slice(-2)} (1st April ${currentFiscalYear} to 31st March ${currentFiscalYear + 1})`,
    });
  }

  fiscalYears.push({
    value: `FY ${String(nextFiscalYear).slice(-2)} (1st April ${nextFiscalYear} to 31st March ${nextFiscalYear + 1})`,
    label: `FY ${String(nextFiscalYear).slice(-2)} (1st April ${nextFiscalYear} to 31st March ${nextFiscalYear + 1})`,
  });

  return fiscalYears;
};


export const initialFormData = {
  FYear: "",
  opexID: "",
  opexBudget:"",
  effectiveDate:"",
  // startDate:"",
  // endDate:"",
  // comments:""
};

export const isInitialFormDataEmptyOrZero = (props) => {
  for (const key in props) {
    if (props.hasOwnProperty(key)) {
      const value = props[key];
      if (value === undefined || value === null || value === '' || value === 0) {
        return true;
      }
    }
  }
  return false;
};

export const isPastFiscalYear = (fiscalYearString) => {
  const match = fiscalYearString.match(/(\d{1,2})(st|nd|rd|th) March (\d{4})/);
  
  if (match) {
    const endDay = parseInt(match[1], 10);
    const endMonth = 2; 
    const endYear = parseInt(match[3], 10);

    const endDate = new Date(endYear, endMonth, endDay);

    const currentDate = new Date();
    if (endDate < currentDate) {
      return true;
    }
  }
  return false;
};

export const getDisabledFy = (userRole, fiscalYearStr) => {
  const startYearMatch = fiscalYearStr.match(/1st April (\d{4})/);
  
  if (!startYearMatch) {
    return false;
  }

  const startYear = parseInt(startYearMatch[1], 10);
  const currentYear = new Date().getFullYear();

  const fiscalYearStart = new Date(`April 1, ${startYear}`);
  const fiscalYearEnd = new Date(`March 31, ${startYear + 1}`);

  const currentDate = new Date();

  // Check if the userRole includes "Operation"
  if (userRole.includes("Operation")) {
    return true;
  } else {
    // Check if the current date falls within the fiscal year range
    if (currentDate >= fiscalYearStart && currentDate <= fiscalYearEnd) {
      return false;
    }
  }
  
  return true;
};

export const maxMinYears = (input) => {
  const yearMatches = input.match(/(\d{4})/g);

  if (yearMatches && yearMatches.length === 2) {
    const startYear = yearMatches[0];  // 2024
    const endYear = yearMatches[1];    // 2025

    console.log("04/"+startYear);
    console.log("03/"+endYear);
    return {
      maxDate:"03/"+endYear,
      minDate:"04/"+startYear
    }
  } else {
    console.error("Unable to extract years");
  }
}
const validateDateFormat = (input) => {
  const regex = /^(0?[1-9]|1[0-2])\/\d{4}$/;
  return regex.test(input);
};
export const formatDateString = (dateString) => {
  if(dateString && validateDateFormat(dateString)){
      const [month, year] = dateString.split('/');
      const formattedMonth = month.padStart(2, '0');
      return `${formattedMonth}/${year}`;
  }
};